import React from 'react'

const Time = (props) => {
  return <div className="text-white pl-2">{props.time}</div>
}

export default Time
